import { enumSchema } from '@shared/utils/enum.utils';

import { TimeEntryDataType } from '../enums';
import { TimeEntryType } from '../enums/time-entry-type.enum';
import { getTranslationDictionarySchema, TranslationDictionary } from '../translate';

export interface TimeEntryCategory {
  id: string;
  name: string;
  nameTranslation: TranslationDictionary;
  wageType: string;
  order: number;
  factor: number;
  type: TimeEntryType;
  isTaxDeduced: boolean;
  dataType: TimeEntryDataType;
  editableInMobileApp: boolean;
}

export const timeEntryCategoryChatbotFields = {
  id: { type: 'string', description: 'Must be specified for update or delete.' },
  type: enumSchema('TimeEntryType', TimeEntryType, 'Required when adding.'),
  nameTranslation: getTranslationDictionarySchema(
    'Required when adding, otherwise should be only set if the intend is to change it.'
  ),
  wageType: { type: 'string' },
  factor: { type: 'number' },
  dataType: enumSchema('TimeEntryDataType', TimeEntryDataType, 'Required when adding.'),
  isTaxDeduced: { type: 'boolean' },
  editableInMobileApp: { type: 'boolean' },
};
